import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'notification_blacklist'

  static get fields () {
    return {
      id: new UUID(),
      email: new STRING(),
      phone_number: new STRING(),
      reason: new STRING(),
      created_at: new STRING(),
      updated_at: new STRING(),
      deleted: new BOOLEAN(),
      deleted_at: new STRING(),
      profile: new ITEM(Profile)
    }
  }
}
